import { render, staticRenderFns } from "./getstartView.vue?vue&type=template&id=566f9964&"
import script from "./getstartView.vue?vue&type=script&lang=js&"
export * from "./getstartView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports